import { heroLead, heroMiniStories } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 pt-8 md:pt-12 pb-8 md:pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-8 lg:gap-12 items-stretch">
          {/* text column */}
          <div className="flex flex-col justify-center fade-rise">
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-label">
                <i className="ri-fire-fill" aria-hidden="true"></i>
                {heroLead.kicker}
              </span>
              <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 inline-block"></span>
                今日头条 · 持续更新中
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-[42px] leading-snug md:leading-[1.3] font-bold text-foreground-950">
              {heroLead.title}
            </h1>

            <p className="mt-5 text-sm md:text-base leading-7 text-foreground-700 max-w-2xl">
              {heroLead.summary}
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-edit-2-line" aria-hidden="true"></i>
                {heroLead.meta}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {heroLead.reads}
              </span>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#timeline"
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label flex items-center justify-center gap-2 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-article-line" aria-hidden="true"></i>
                查看完整事件梳理
              </a>
              <a
                href="#collections"
                className="h-11 px-6 rounded-md border border-foreground-300 text-foreground-800 text-sm font-label flex items-center justify-center gap-2 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-bookmark-line" aria-hidden="true"></i>
                收藏这期吃瓜合集
              </a>
            </div>
          </div>

          {/* image column */}
          <figure className="relative rounded-lg overflow-hidden border border-background-300 bg-background-100 min-h-[320px] lg:min-h-[460px]">
            <img
              src={heroLead.image}
              alt="51黑料今日爆料封面配图"
              title="51黑料今日爆料 · 大瓜事件封面"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/10 to-transparent"></div>
            <figcaption className="absolute left-0 right-0 bottom-0 p-4 md:p-5 text-background-50">
              <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm bg-accent-500 text-foreground-950 text-[11px] font-label mb-2">
                封面故事
              </span>
              <p className="text-sm md:text-base font-label leading-6">
                配图仅作版式示意，内容以正文描述与时间线为准
              </p>
            </figcaption>
          </figure>
        </div>

        {/* mini stories strip */}
        <div className="rule-dotted h-px mt-9 md:mt-12"></div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 pt-6">
          {heroMiniStories.map((story) => (
            <a key={story.title} href="#today" className="group block">
              <span className="text-xs font-label text-primary-600">{story.category}</span>
              <p className="mt-2 text-sm md:text-[15px] font-medium text-foreground-900 leading-6 group-hover:text-primary-600 transition-colors">
                {story.title}
              </p>
              <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-time-line" aria-hidden="true"></i>
                {story.time}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}